import { render, staticRenderFns } from "./README.md?vue&type=template&id=63d2a874&scoped=true&"
import script from "./README.md?vue&type=script&lang=js&"
export * from "./README.md?vue&type=script&lang=js&"
import style0 from "./README.md?vue&type=style&index=0&id=63d2a874&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d2a874",
  null
  
)

component.options.__file = "README.md"
export default component.exports